import accounting from 'accounting'

const filtro = (valor, prefixo, quantidadeCasasDecimais) => {
	if (valor === null || valor === undefined || quantidadeCasasDecimais === null || quantidadeCasasDecimais < 0) {
		return '--'
	}
	return accounting.formatMoney(valor, prefixo, quantidadeCasasDecimais, '.', ',')
}

export default filtro
